import React, { useState, useRef } from "react";
import { useTranslation, Trans } from "react-i18next";
import TurnstileWidget from "../utils/TurnstileWidget";
import emailjs from "@emailjs/browser";
import Loader from "../utils/Loader";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

export const ContactFormSection = () => {
  const { t } = useTranslation();
  const [verificationResult, setVerificationResult] = useState(null);
  const form = useRef();
  const [loading, setLoading] = useState(false);
  const [user_name, setName] = useState("");
  const [user_phone, setPhone] = useState("");
  const [user_adress, setAdress] = useState("");
  const [user_email, setEmail] = useState("");
  const [user_message, setMessage] = useState("");
  const [openAlert, setOpenAlert] = useState(false);
  const [typeAlert, setTypeAlert] = useState("danger");
  const [messageAlert, setMessageAlert] = useState("");

  const handleVerification = (result) => {
    setVerificationResult(result);
  };

  const sendEmail = (e) => {
    e.preventDefault();
    const data = {
      user_name,
      user_phone,
      user_adress,
      user_email,
      user_message,
    };
    setLoading(true);
    emailjs
      .send("service_wwljt6t", "template_tytnd7v", data, "oLFY5bLKiHMMjaxsg")
      .then(
        (result) => {
          console.log(result.text);
          setTypeAlert("success");
          setMessageAlert(t("shared.email_sent"));
          setOpenAlert(true);
          setLoading(false);
          e.target.reset();
        },
        (error) => {
          console.log(error.text);
          setTypeAlert("error");
          setMessageAlert(error.text);
          setOpenAlert(true);
          setLoading(false);
        }
      );
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  return (
    <>
      <section className="form-section">
        <div className="info-container">
          <h1>{t("contact.title")}</h1>
          <br />
          <p>
            <b>{t("contact.mon-fri")}:</b> 9:00 - 16:00
          </p>
          <br />
          <p>
            <Trans t={t} i18nKey="contact.description" />
          </p>
        </div>
        <div className="form-container">
          <h1>{t("contact.form.title")}</h1>
          <form ref={form} onSubmit={sendEmail}>
            <div className="form-row">
              <div>
                <label htmlFor="name">
                  {t("contact.form.name")}{" "}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="telnr">
                  {t("contact.form.telnr")}{" "}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="tel"
                  id="telnr"
                  name="telnr"
                  required
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>
            </div>
            <br />
            <div>
              <label htmlFor="adress">
                {t("contact.form.address")}{" "}
                <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                id="adress"
                name="adress"
                required
                onChange={(e) => setAdress(e.target.value)}
              />
            </div>
            <br />
            <div>
              <label htmlFor="email">
                {t("contact.form.email")}{" "}
                <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="email"
                id="email"
                name="email"
                required
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <br />
            <div>
              <label htmlFor="message">
                {t("contact.form.message")}{" "}
                <span style={{ color: "red" }}>*</span>
              </label>
              <br />
              <textarea
                id="message"
                name="message"
                required
                style={{ maxWidth: "100vh", height: "100px" }}
                onChange={(e) => setMessage(e.target.value)}
              />
            </div>
            <TurnstileWidget onVerification={handleVerification} />
            {loading ? (
              <Loader loading={loading} height={40} width={40} />
            ) : (
              <button
                disabled={!verificationResult}
                className="link-button"
                type="submit"
              >
                {t("shared.submit")}
              </button>
            )}
          </form>
        </div>
      </section>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openAlert}
        autoHideDuration={10000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={typeAlert}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {messageAlert}
        </Alert>
      </Snackbar>
    </>
  );
};
